<template>
    <table class="table table-bordered table-striped table-vcenter dataTable" style="width: 100%;">
        <thead>
            <tr>
                <th v-if="!this.hide.includes('reg')">Reg</th>
                <th v-if="!this.hide.includes('colour')">Colour</th>
                <th v-if="!this.hide.includes('make')">Make</th>
                <th v-if="!this.hide.includes('model')">Model</th>
                <th v-if="!this.hide.includes('customer')">Customer</th>
                <th v-if="!this.hide.includes('type')">Type</th>
                <th v-if="!this.hide.includes('actions')">Actions</th>
            </tr>
        </thead>
        <tbody></tbody>
    </table>
</template>

<script>
import { buildColumns } from "@/helpers/build-columns";

export default {
    props: {
        ajaxUrl: String,
        hide: {
            type: Array,
            default: () => [],
            required: false
        },
    },

    data() {
        return {
            columnDefinitions: {
                reg: {
                    data: 'reg',
                },
                colour: {
                    data: 'colour',
                },
                make: {
                    data: 'make',
                },
                model: {
                    data: 'model',
                },
                customer: {
                    name: 'customer.name',
                    orderable: false,
                    render: function (data, type, row) {
                        return row.computed_customer;
                    },
                },
                type: {
                    data: 'vehicle_type.type',
                    orderable: false,
                    searchable: false,
                },
                actions: {
                    data: 'actions',
                    name: 'actions',
                    searchable: false,
                    orderable: false,
                    width: '200px',
                }
            }
        }
    },

    mounted() {
        window.jQuery(this.$el).DataTable({
            processing: true,
            serverSide: true,
            pageLength: 25,
            lengthMenu: [25, 50, 100],
            ajax: {
                url: this.ajaxUrl,
            },
            order: [[3, 'asc']],
            columnDefs: this.setColumnWidths(),
            columns: buildColumns(this.columnDefinitions, this.hide),
        });
    },

    methods: {
        setColumnWidths() {
            let columnDefs = [];

            if (!this.hide.includes('actions')) {
                columnDefs.push({ targets: -1, width: '200px' });
            }

            return columnDefs;
        },
    },
};
</script>
